// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"85":"mobile","367":"personalspace","388":"result","962":"home"}[chunkId] + "." + {"85":"66de1208","367":"7f80e578","388":"4b063dc8","962":"cc1e5fc4"}[chunkId] + ".css";
};